export default "__VITE_ASSET__C7te6E2W__"